export const USER_INFO = "USER_INFO";
export const JOB_CATEGORY = "JOB_CATEGORY";

export const USER_TOKEN = "USER_TOKEN";
export const USER_EDIT_TOKEN = "USER_EDIT_TOKEN";

export const MODALITY_OPTIONS = "MODALITY_OPTIONS";
export const PAYMENT_CATEGORY_OPTIONS = "PAYMENT_CATEGORY_OPTIONS";

export const INSURANCE_PROVIDER_OPTIONS = "INSURANCE_PROVIDER_OPTIONS";
export const SERVICE_CATEGORY_OPTIONS = "SERVICE_CATEGORY_OPTIONS";

// export const MEMBER_SERVICES = "MEMBER_SERVICES";

export const COMPLIANCE_DOCUMENT_CATEGORY_OPTIONS = "COMPLIANCE_DOCUMENT_CATEGORY_OPTIONS";

export const OPTIONS_EXPIRY_TIME = "OPTIONS_EXPIRY_TIME";
export const USER_INFO_EXPIRY_TIME = "USER_INFO_EXPIRY_TIME";
export const MEMBERSHIP_STATUS_OPTIONS = "MEMBERSHIP_STATUS_OPTIONS";
export const CONTACT_TYPE_OPTIONS = "CONTACT_TYPE_OPTIONS";
export const MEMBERSHIP_LEVEL_OPTIONS = "MEMBERSHIP_LEVEL_OPTIONS";

export const PHOTO_ID_DOCUMENT_CATEGORY_OPTIONS = "PHOTO_ID_DOCUMENT_CATEGORY_OPTIONS";
export const CHANGE_SECTION_CATEGORY_OPTIONS = "CHANGE_SECTION_CATEGORY_OPTIONS";

export const QUALIFICATION_ATTACHMENT_CATEGORY_OPTIONS = "QUALIFICATION_ATTACHMENT_CATEGORY_OPTIONS";
export const QUALIFICATION_TYPES = "QUALIFICATION_TYPES";

export const HEALTH_FUND_OPTIONS = "HEALTH_FUND_OPTIONS";

export const CPD_PROVIDER_OPTIONS = "CPD_PROVIDER_OPTIONS";

export const PERMISSION_ROLE_OPTIONS = "PERMISSION_ROLE_OPTIONS";

export const MEMBER_TYPE_OPTIONS = "MEMBER_TYPE_OPTIONS";

export const EXPORTABLE_DATA = "EXPORTABLE_DATA";
export const EXPORTABLE_DATA_EXPIRY = "EXPORTABLE_DATA_EXPIRY";

export const PUBLIC_DOCUMENT_CATEGORY = "PUBLIC_DOCUMENT_CATEGORY";

export const APPROVAL_NOTES_LIST = "APPROVAL_NOTES_LIST";
export const APPROVAL_NOTES_LIST_EXPIRY = "APPROVAL_NOTES_LIST_EXPIRY";

export const LATEST_LOGIN_VERSION = "LATEST_LOGIN_VERSION";

export const NOTIFICATION_CATEGORIES = "NOTIFICATION_CATEGORIES";

export const EVENT_TAG_OPTIONS = "EVENT_TAG_OPTIONS";

export const TEMP_PASS_CONTACT_IDS = "TEMP_PASS_CONTACT_IDS";

export const CPD_LOCAL_DRAFT = "CPD_LOCAL_DRAFT";
export const NEWS_LOCAL_DRAFT = "NEWS_LOCAL_DRAFT";

// Joyride
export const JOYRIDE_DELETE_CPD_ENROLLMENT_LEARNED = "JOYRIDE_DELETE_CPD_ENROLLMENT_LEARNED";